function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
var _excluded = ["className", "current", "isNavItem", "isFirst", "children"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Button, DialogTrigger, Link } from '../index';
var propTypes = {
  /** Additional styling */
  className: PropTypes.string,
  /** Set option as the current when used as a navigation item */
  current: PropTypes.bool,
  /** Used with OverflowMenu `isNav` */
  isNavItem: PropTypes.bool,
  /** Used to set focus by the parent OverflowMenuOptionsList when rendered */
  isFirst: PropTypes.bool,
  /** Button, Link, or DialogTrigger */
  children: function children(props, propName, componentName) {
    var children = React.Children.toArray(props[propName]);
    var invalidChildren = children.filter(function (child) {
      return child.type.displayName !== DialogTrigger.displayName && child.type.displayName !== Button.displayName && child.type.displayName !== Link.displayName;
    });
    if (children.length === 0 || invalidChildren.length > 0) {
      return new Error("".concat(componentName, " expects one or more children of type Button or DialogTrigger"));
    }
    return null;
  }
};
var defaultProps = {
  className: undefined,
  current: false,
  isNavItem: false,
  isFirst: false,
  children: undefined
};
var OverflowMenuOption = function OverflowMenuOption(_ref) {
  var className = _ref.className,
    current = _ref.current,
    isNavItem = _ref.isNavItem,
    isFirst = _ref.isFirst,
    children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var styleClass = classnames('wds-c-overflow-menu__option-item', {
    'wds-c-overflow-menu__option-item--current': current && isNavItem
  }, className);
  var menuItemContents = React.Children.map(children, function (child) {
    var settings = _objectSpread({
      role: isNavItem ? undefined : 'menuitem',
      className: classnames(child.props.className, 'wds-c-overflow-menu__option-item-control')
    }, otherProps);
    return child && /*#__PURE__*/React.cloneElement(child, settings);
  });
  return /*#__PURE__*/React.createElement("li", _extends({
    ref: function ref(listItem) {
      if (isFirst && listItem) {
        /* If component is first in list, focus on its action item */
        var focusTarget = listItem.querySelector('button') || listItem.querySelector('a');
        if (focusTarget) {
          focusTarget.focus();
        }
      }
    },
    className: styleClass
  }, isNavItem ? {} : {
    role: 'none',
    tabIndex: -1
  }, otherProps), menuItemContents);
};
OverflowMenuOption.propTypes = propTypes;
OverflowMenuOption.defaultProps = defaultProps;
OverflowMenuOption.displayName = 'OverflowMenuOption';
export default OverflowMenuOption;